import r from "./index806.js";
import e from "./index877.js";
import o from "./index878.js";
function n(t) {
  return o(e(t, void 0, r), t + "");
}
export {
  n as default
};
